import React from 'react';
import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';

const hasAuthToken = () => {
  if (typeof window === 'undefined') return false;
  const hasTokenLikeValue = (v) => {
    if (!v) return false;
    const n = String(v).trim().toLowerCase();
    return n !== 'null' && n !== 'undefined' && n !== '';
  };
  const storedSession = window.localStorage.getItem('session');
  let hasSessionToken = false;
  if (hasTokenLikeValue(storedSession)) {
    try {
      hasSessionToken = hasTokenLikeValue(JSON.parse(storedSession)?.access_token);
    } catch (_) {}
  }
  return (
    ['token', 'access_token', 'refresh_token'].some((k) =>
      hasTokenLikeValue(window.localStorage.getItem(k))
    ) || hasSessionToken
  );
};

const NotFound = () => {
  const homeRoute = hasAuthToken() ? '/application-dashboard' : '/login';

  return (
    <div className="relative min-h-screen flex items-center justify-center bg-[#0D0D0E] overflow-hidden">
      <div className="absolute inset-0 bg-[linear-gradient(rgba(59,130,246,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(59,130,246,0.03)_1px,transparent_1px)] bg-[size:48px_48px] pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_600px_at_50%_40%,rgba(59,130,246,0.06),transparent)] pointer-events-none" />

      <div className="relative z-10 flex flex-col items-center text-center px-6 py-16 max-w-md w-full mx-4 bg-[#101012] border border-[#232325] rounded-2xl shadow-2xl">
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-blue-500/10 border border-blue-500/30 mb-6">
          <FileQuestion className="w-10 h-10 text-blue-400" />
        </div>

        <h1 className="text-white text-3xl font-bold mb-3 tracking-tight">
          404 — Page Not Found
        </h1>

        <p className="text-gray-400 text-base leading-relaxed mb-8">
          The page you're looking for doesn't exist or you don't have access to it.
        </p>

        <Link
          to={homeRoute}
          className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-150"
        >
          Go back to dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
